
import EventBus from '@/components/services/EventBus.js';
import http from '@/components/services/http-common';
import UploadService from "@/components/services/UploadService";
import moment from 'moment/moment';
import AssignmentDialog from '@/views/HR/Assignment/Create';
import WorkHistoryDialog from '../WorkHistoryDialog';
import LeaveEnrollHistoryDialog from '../LeaveEnrollHistory';
import LeaveEnrollDialog from '@/views/HR/LeaveEnroll/Create';
import CreateContractDialog from '@/views/HR/Contract/Create';
import CreateUserDialog from '@/views/HR/User/Create';
import EmployeeTypeDetail from '../EmployeeTypeDetail';

import ListContractDialog from '../ListContract';
import LanguageDialog from '../LanguageDialog.vue';
import EmployeePrintCV from '../EmployeePrintCV.vue';

import TabAttachment from '../tabs/TabAttachment.vue';
import TabFamily from '../tabs/TabFamily.vue';
import TabBenefit from '../tabs/TabBenefit.vue';
import TabLeave from '../tabs/TabLeave.vue';
import TabLog from '../tabs/TabLog.vue';
import FileUpload from '@/components/FileUpload.vue';

import { create } from './data'
export default {
    components: {
        "employee-print-cv": EmployeePrintCV,
        "language-dialog": LanguageDialog,
        "assignment-dialog": AssignmentDialog,
        "work-history-dialog": WorkHistoryDialog,
        "leaveEnroll-history-dialog": LeaveEnrollHistoryDialog,
        "leave-enroll-dialog": LeaveEnrollDialog,
        "create-contract-dialog": CreateContractDialog,
        "create-user-dialog": CreateUserDialog,
        "list-contract-dialog": ListContractDialog,
        EmployeeTypeDetail,
        "tab-attachment": TabAttachment,
        "tab-family": TabFamily,
        "tab-benefit": TabBenefit,
        "tab-leave": TabLeave,
        "tab-log": TabLog,
        "file-upload": FileUpload
    },
    props: ["value", "item"],
    watch: {
        statuses: {
            handler(value) {
                this.statusConvert(value);
            }
        },
        dialog: {
            handler(value) {
                this.fetchCity();
                this.fetchAltCities();
                this.fetchEducationLevel();
                this.fetchUniversity();
                this.fetchAcademicRank();
                this.fetchEducationMajor();
                this.fetchEthinicity();
                this.fetchReligion();
                this.fetchOrigins();
                this.fetchArea();
                this.fetchBank();
                this.fetchFamily()

                if (value) {
                    if (this.isEdit) {
                        this.fetch().then(() => {
                            this.fetchDDistrict(this.form.domicileCityCode, true);
                            this.fetchDistrict(this.form.cityCode, true);
                            this.fetchDWard(this.form.domicileDistrictCode, true);
                            this.fetchWard(this.form.districtCode, true);
                            this.fetchAltWards1(true);
                            this.fetchAltWards2(true);
                        })
                        this.fetchStatusDetail();
                        this.fetchPromoteDetail();
                        this.fetchRotationDetail();
                    }
                }
                else {
                    this.close();
                }
            }
        },

        "form.isVerified": {
            handler(val) {
                this.globalIsVerified = val;
            }
        },

        // idPlaceCombine:{
        //     handler(val) {
        //         this.form.iDplace = val;
        //     }
        // }
    },
    computed: {
        avatar() {
            if (this.form.avatar)
                return (this.form.avatar.includes("http") ? "" : process.env.VUE_APP_BASE_URL) + this.form.avatar.replace('wwwroot/', '');
            else
                return '/sample.png';
        },
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val) {
                this.$emit("input", val)
            }
        },
        isEdit() {
            return !!this.item;
        },
        // idPlaceCombine() {
        //     return `${this.idPlaceAuth} - ${this.idPlaceLoc}`;
        // },
        idPlaces() {
            let fixedData = ["Cục Cảnh sát ĐKQL cư trú và DLQG về dân cư", "Cục Cảnh sát quản lý hành chính về trật tự xã hội", "Hàn Quốc", "Bộ Công An"];
            let cityData = this.cities.map(x => { return x.name });
            return fixedData.concat(cityData);
        },
        idCards() {
            return [
                { label: 'MẶT TRƯỚC CCCD', src: this.form.idFrontImageUrl, placeholder: 'https://placehold.co/400x250/f5f5f5/a0a0a0?text=CCCD+Truoc', filename: 'CCCD_Truoc.jpg' },
                { label: 'MẶT SAU CCCD', src: this.form.idBackImageUrl, placeholder: 'https://placehold.co/400x250/f5f5f5/a0a0a0?text=CCCD+Sau', filename: 'CCCD_Sau.jpg' },
                { label: 'TÀI KHOẢN NGÂN HÀNG', src: this.form.bankImageUrl, placeholder: 'https://placehold.co/400x250/f5f5f5/a0a0a0?text=Ngan+Hang', filename: 'bank.jpg' },
                { label: 'XÁC NHẬN KẾT HÔN', src: this.form.maritalImageUrl, placeholder: 'https://placehold.co/400x250/f5f5f5/a0a0a0?text=Ket+Hon', filename: 'Kethon.jpg' },
                { label: 'XÁC NHẬN TÔN GIÁO', src: this.form.religionImageUrl, placeholder: 'https://placehold.co/400x250/f5f5f5/a0a0a0?text=Ton+Giao', filename: 'Tongiao.jpg' }
            ];
        },
        jobApplicationCards() {
            return [
                { label: 'ĐƠN XIN VIỆC', src: this.form.applicationUrl, icon: 'mdi-file-document-edit-outline', field: 'applicationUrl', filename: 'DonXinViec.pdf' },
                { label: 'SƠ YẾU LÝ LỊCH', src: this.form.resumeUrl, icon: 'mdi-account-details-outline', field: 'resumeUrl', filename: 'SoYeuLyLich.pdf' },
                { label: 'HỘ KHẨU / TẠM TRÚ', src: this.form.residenceUrl, icon: 'mdi-home-city-outline', field: 'residenceUrl', filename: 'HoKhau_TamTru.pdf' },
                { label: 'GIẤY KHÁM SỨC KHỎE', src: this.form.healthCertUrl, icon: 'mdi-heart-pulse', field: 'healthCertUrl', filename: 'GiayKhamSucKhoe.pdf' }
            ];
        },
        degreeCards() {
            return [
                { label: 'BẰNG CẤP / CHỨNG CHỈ (1)', src: this.form.educationCert1Url, icon: 'mdi-certificate-outline', field: 'educationCert1Url', filename: 'BangCap1.pdf' },
                { label: 'BẰNG CẤP / CHỨNG CHỈ (2)', src: this.form.educationCert2Url, icon: 'mdi-certificate-outline', field: 'educationCert2Url', filename: 'BangCap2.pdf' },
                { label: 'BẰNG CẤP / CHỨNG CHỈ (3)', src: this.form.educationCert3Url, icon: 'mdi-certificate-outline', field: 'educationCert3Url', filename: 'BangCap3.pdf' },
                { label: 'BẰNG CẤP / CHỨNG CHỈ (4)', src: this.form.educationCert4Url, icon: 'mdi-certificate-outline', field: 'educationCert4Url', filename: 'BangCap4.pdf' },
                { label: 'BẰNG CẤP / CHỨNG CHỈ (5)', src: this.form.educationCert5Url, icon: 'mdi-certificate-outline', field: 'educationCert5Url', filename: 'BangCap5.pdf' }
            ];
        }

    },
    data() {
        return {
            ...create,
            printPreviewDialog: false,
            viewImageDialog: false,
            currentImageUrl: ''
        };
    },
    methods: {

        formatDate(value, format = "DD/MM/YYYY") {
            return moment(value).format(format);
        },
        downloadAvatar() {
            if (!this.avatar) {
                alert("Không tìm thấy ảnh đại diện để tải xuống.");
                return;
            }
            const a = document.createElement('a');
            a.href = this.avatar;
            a.download = `avatar_${this.form?.code || 'employee'}.jpg`;
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        viewImageDialogFunc(url) {
            if (!url || url.includes('placehold.co')) return;
            this.currentImageUrl = url;
            this.viewImageDialog = true;
        },
        downloadImageFile(url, fileName) {
            if (!url || url.includes('placehold.co')) return;
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName || 'document.jpg';
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        printProfile() {
            this.printPreviewDialog = true;
        },
        executePrint() {
            let printArea = document.getElementById('printCvArea');
            let w = window.open('', '_blank', 'width=800,height=900');
            // Copy html head incl css
            let headHtml = document.head.innerHTML;
            w.document.write('<html><head><title>Hồ sơ nhân viên (Bản In)</title>');
            w.document.write(headHtml);
            // Append print specific cleanups
            w.document.write('<style>body { background-color: white !important; margin: 0; padding: 0;} @page { margin: 10mm; size: A4 portrait;} * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }</style>');
            w.document.write('</head><body>');
            w.document.write(printArea.innerHTML);
            w.document.write(`
                <script>
                    window.onload = function() {
                        setTimeout(() => {
                            window.print();
                        }, 500);
                    };
                </script>
            `);
            w.document.write('</body></html>');
            w.document.close();
            this.printPreviewDialog = false;
        },
        chooseAvatar() {
            this.$refs.avatarInput.$refs.input.click()
        },

        uploadAvatar(files) {
            if (!files) return;
            UploadService.upload(files, (event) => {
            }, "employees/avatar")
                .then((response) => {
                    this.form.avatar = response.data.path;
                })
        },
        uploadDocument(files, field, index = null) {
            if (!files) return;
            UploadService.upload(files, (event) => {
            }, "employees/documents")
                .then((response) => {
                    if (index !== null) {
                        if (!this.form[field]) this.$set(this.form, field, []);
                        this.$set(this.form[field], index, response.data.path);
                    } else {
                        this.$set(this.form, field, response.data.path);
                    }
                })
        },
        deleteDocument(field, index = null) {
            if (index !== null) {
                this.$set(this.form[field], index, '');
            } else {
                this.$set(this.form, field, '');
            }
        },
        openCertDialog() {
            this.certEditIndex = -1;
            this.certForm = { id: null, type: '', title: '', attachmentUrl: '' };
            this.certDialog = true;
        },
        openPdf(url) {
            window.open(url, '_blank');
        },
        editCert(item) {
            this.certEditIndex = this.form.employeeCertificates.indexOf(item);
            this.certForm = Object.assign({}, item);
            this.certDialog = true;
        },
        deleteCert(item) {
            if (confirm('Bạn có chắc chắn muốn xóa chứng chỉ này?')) {
                let index = this.form.employeeCertificates.indexOf(item);
                if (item.id) {
                    http.delete(`Employees/certificate/${item.id}`).then(() => {
                        if (index > -1) {
                            this.form.employeeCertificates.splice(index, 1);
                        }
                    });
                } else {
                    if (index > -1) {
                        this.form.employeeCertificates.splice(index, 1);
                    }
                }
            }
        },
        saveCert() {
            if (!this.form.employeeCertificates) this.$set(this.form, 'employeeCertificates', []);

            let payload = {
                title: this.certForm.title,
                type: this.certForm.type,
                attachmentUrl: this.certForm.attachmentUrl,
                employeeCode: this.form.code || (this.item ? this.item.code : null)
            };

            if (this.certForm.id) {
                http.put(`Employees/certificate/${this.certForm.id}`, payload).then(res => {
                    if (this.certEditIndex > -1) {
                        this.$set(this.form.employeeCertificates, this.certEditIndex, Object.assign({}, this.certForm));
                    }
                    this.closeCertDialog();
                });
            } else {
                http.post(`Employees/certificate`, payload).then(res => {
                    let newCert = Object.assign({}, this.certForm);
                    if (res.data && res.data.id) newCert.id = res.data.id;
                    else if (res.data && res.data.data && res.data.data.id) newCert.id = res.data.data.id;

                    if (!newCert.id) {
                        this.fetch();
                    } else {
                        this.form.employeeCertificates.push(newCert);
                    }
                    this.closeCertDialog();
                });
            }
        },
        closeCertDialog() {
            this.certDialog = false;
        },
        fetchFamily() {
            return http.get('employeeFamilies/get-from-employee/' + this.item?.code).then(res => {
                this.families = res.data.data
            })
        },
        fetchEthinicity(val) {
            return http.get("ethnicities").then(res => {
                this.ethnicities = res.data;
            });
        },

        fetchReligion(val) {
            return http.get("religions").then(res => {
                this.religions = res.data;
            });
        },
        fetchOrigins(val) {
            return http.get("origins").then(res => {
                this.origins = res.data;
            });
        },
        fetchCity() {
            return http.get('cities/fetch').then(res => {
                this.cities = res.data.data;
                this.dCities = res.data.data;
            });
        },

        fetchBank() {
            return http.get('banks').then(res => {
                this.banks = res.data;
            });
        },
        fetchDDistrict(val, init = false) {
            if (!init) {
                this.dDistricts = [];
                this.form.domicileDistrictCode = null;
            }
            return http.get('cities/fetch-district/' + val).then(res => {
                this.dDistricts = res.data;
            });
        },
        fetchDistrict(val, init = false) {
            if (!init) {
                this.districts = [];
                this.form.districtCode = null;
                this.wards = [];
                this.form.wardCode = null;
            }
            return http.get('cities/fetch-district/' + val).then(res => {
                this.districts = res.data;
            });
        },
        fetchWard(val, init = false) {
            if (!init) {
                this.wards = [];
                this.form.wardCode = null;
            }
            if (val == null)
                return;
            return http.get('districts/fetch-ward/' + val).then(res => {
                this.wards = res.data;
            });
        },
        fetchDWard(val, init = false) {
            if (!init) {
                this.dWards = [];
                this.form.domicileWardCode = null;
            }
            if (val == null)
                return;
            return http.get('districts/fetch-ward/' + val).then(res => {
                this.dWards = res.data;
            });
        },
        fetchEducationLevel() {
            return http.get('educationLevels/fetch').then(res => {
                this.educationLevels = res.data;
            })
        },
        fetchUniversity() {
            return http.get('universities/fetch').then(res => {
                this.universities = res.data;
            })
        },
        fetchEducationMajor() {
            return http.get('educationMajors/fetch').then(res => {
                this.educationMajors = res.data;
            })
        },
        fetchAcademicRank() {
            return http.get('academicRanks/fetch').then(res => {
                this.academicRanks = res.data;
            })
        },
        fetchArea() {
            return http.get("areas/fetch").then(res => {
                this.areas = res.data;
            })
        },
        fetchBenefitMans() {
            return http.get("benefitManagers/emp/" + this.item.code).then(res => {
                this.benefitMans = res.data.data;
            })
        },

        fetchLeaveEnrollment() {
            return http.get('leaveEnrollments/fetch-amount/' + this.item.code).then(res => {
                this.leaveEnrollments = res.data.data
            })
        },

        fetchAltCities() {
            return http.get('addresses/cities').then(res => {
                this.altCities = res.data.data
            })
        },

        fetchAltWards1(init = false) {
            if (!init) {
                this.altWards1 = [];
                this.form.newWardId1 = null;
            }
            let cityId = this.form.newCityId
            if (cityId)
                return http.get('addresses/wards?cityId=' + cityId).then(res => {
                    this.altWards1 = res.data.data
                })
        },

        fetchAltWards2(init = false) {
            if (!init) {
                this.altWards2 = [];
                this.form.newWardId2 = null;
            }
            let cityId = this.form.newCityId2
            if (cityId)
                return http.get('addresses/wards?cityId=' + cityId).then(res => {
                    this.altWards2 = res.data.data
                })
        },

        fetch() {
            this.isLoading = true
            return http.get(this.ROOT_URL + this.item.code).then(res => res.data.data).then(d => {
                this.form = Object.assign({}, d.employeeDetailView);
                // this.form.awards = d.employeeDetailView.employeeAwards || [];
                this.statusAction = d.actionHistories;
                this.statusText = this.form.status;
                // this.statusHistory = d.status_history;
                switch (this.form.status) {
                    case "Hoạt Động": {
                        this.form.status = "1"
                        break;
                    }
                    case "Tạm Nghỉ": {
                        this.form.status = "2"
                        break;
                    }
                    case "Thai Sản": {
                        this.form.status = "3"
                        break;
                    }
                    case "Nghỉ Việc": {
                        this.form.status = "4"
                        break;
                    }
                    case "Ẩn": {
                        this.form.status = "5"
                        break;
                    }

                    case "Cần xác thực": {
                        this.form.status = ""
                        break;
                    }
                }
                // this.splitIdPlace(res.data.employee.iDplace);
            }).then(() => {
                this.fetchRotationDetail()
                this.fetchPromoteDetail()
                this.fetchStatusDetail()
                this.fetchBenefitMans()
                this.fetchLeaveEnrollment()
            }).finally(() => {
                this.isLoading = false
            })
        },

        editStatusHistory(item) {
            this.updateStatusHistoryDialog = !this.updateStatusHistoryDialog;
            let FETCH_URL = `employees/status-history-get/${item.code}`

            return http.get(FETCH_URL).then(res => {
                let obj = {
                    code: res.data.item.code,
                    status: res.data.item.status,
                    date: res.data.item.date,
                    endDate: res.data.item.endDate
                };
                this.UpdateStatusHistoryObj = Object.assign({}, obj);
            });
        },

        confDeleteStatusHistory(item) {
            this.deleteStatusHistoryDialog = true;
            this.DeleteStatusHistoryObj = item;
        },

        deleteStatusHistory() {
            this.deleteStatusHistoryDialog = !this.deleteStatusHistoryDialog;
            let FETCH_URL = `employees/status-history-delete/${this.DeleteStatusHistoryObj.code}`
            return http.delete(FETCH_URL,);
        },

        updateStatusHistory() {
            let FETCH_URL = `employees/status-history-update/${this.UpdateStatusHistoryObj.code}`
            return http.put(FETCH_URL, this.UpdateStatusHistoryObj);
        },
        saveData() {
            alert("submit")
            alert(this.LOCK)
            if (!this.LOCK) {
                this.isValid = this.$refs.form.validate();
                alert(this.isValid)
                if (this.isValid) {
                    if (!this.isEdit) {
                        alert("post")
                        return http.post(this.ROOT_URL, this.form).then(res => {
                            this.$emit("fetch");
                            // this.dialog = false;
                        })
                    } else {

                        alert("put")
                        return http.put(this.ROOT_URL + this.item.code, this.form).then(res => {
                            this.$emit("fetch");
                            // this.dialog = false;
                            this.LOCK = true;
                        })
                    }
                } else {
                    this.panels = [0, 1, 2, 3, 4];
                }
            } else {
                let notif = {
                    message: "Bạn chưa mở khóa dữ liệu",
                    icon: 'error',
                    toast: false,
                }
                EventBus.$emit('hasError', notif);
                // this.$eventBus.$emit('hasError', 'i hear you');
            }
        },
        close() {
            this.panels = [0, 1, 2, 3, 4],
                this.leaveEnrollments = []
            this.benefitMans = []
            this.$refs.form.resetValidation();
            this.form = Object.assign({}, this.defaultForm);
            this.form.code = null;
            this.idPlaceAuth = "";
            this.idPlaceLoc = "";
            this.LOCK = true;
        },

        //employeeStatusDetail

        // setStatusHistoryDetailDeleteCfm(item){
        //     this.employeeStatusDetailEditForm.code = item.code;
        //     this.deleteStatusDetailCfm = true;
        // },

        setStatusDetailForm(item) {
            this.employeeStatusDetailEditForm.code = item.code;
            this.employeeStatusDetailEditForm.status = item.status;
            this.employeeStatusDetailEditForm.fromDate = item.fromDate;
            this.employeeStatusDetailEditForm.toDate = item.toDate;
            this.employeeStatusDetailEditForm.note = item.note;
        },

        fetchStatusDetail() {
            return http.get("EmployeeStatusDetails", {
                params: {
                    employeeCode: this.item.code
                }
            }).then(res => {
                this.statusTableItems = res.data;
            });
        },

        openCreateStatusDialog() {
            this.addStatus = !this.addStatus;
        },
        postStatusDetail() {
            this.employeeStatusDetailLoading = true;
            let postDate = {
                status: 1,
                fromDate: null,
                toDate: null,
                note: ''
            };

            postDate.fromDate = moment(this.employeeStatusDetailForm.fromDate, "DD/MM/YYYY").format("YYYY-MM-DD");
            postDate.toDate = moment(this.employeeStatusDetailForm.toDate, "DD/MM/YYYY").format("YYYY-MM-DD");
            postDate.status = this.employeeStatusDetailForm.status;
            postDate.note = this.employeeStatusDetailForm.note

            return http.post("EmployeeStatusDetails/" + this.item.code, postDate).then(res => {
                this.employeeStatusDetailLoading = false;
                this.fetchStatusDetail();
            }).finally(() => {
                this.employeeStatusDetailLoading = false;
                this.addStatus = false;
            });
        },

        setDefaultToDate() {
            if (this.employeeStatusDetailForm.status == 3) {
                if (!!this.employeeStatusDetailForm.fromDate) {
                    this.employeeStatusDetailForm.toDate = moment(this.employeeStatusDetailForm.fromDate, "DD/MM/YYYY").add(6, "months").format("DD/MM/YYYY")
                }
            }
        },

        putStatusDetail(item) {
            //convert date
            let putDate = {
                status: 1,
                fromDate: null,
                toDate: null
            };
            this.employeeStatusDetailLoading = true;

            putDate.fromDate = moment(this.employeeStatusDetailEditForm.fromDate, "DD/MM/YYYY").format("YYYY-MM-DD");
            putDate.toDate = moment(this.employeeStatusDetailEditForm.toDate, "DD/MM/YYYY").format("YYYY-MM-DD");
            putDate.status = this.employeeStatusDetailEditForm.status;
            putDate.note = this.employeeStatusDetailEditForm.note

            //validate
            let valid = true;
            for (var i = 0; i < this.dateValidRules.length; i++) {
                if (this.dateValidRules[i](this.employeeStatusDetailEditForm.toDate) != true)
                    valid = valid && false;
            }
            for (var i = 0; i < this.dateValidRules.length; i++) {
                if (this.dateValidRules[i](this.employeeStatusDetailEditForm.fromDate) != true)
                    valid = valid && false;
            }
            valid = valid && !!this.employeeStatusDetailEditForm.fromDate && !!this.employeeStatusDetailEditForm.toDate && !!this.employeeStatusDetailEditForm.status;

            if (valid) {
                return http.put("EmployeeStatusDetails/" + item.code, putDate).then(res => {
                    this.fetchStatusDetail();
                    this.statusEdit = false;
                }).finally(() => {
                    this.employeeStatusDetailLoading = false;
                });
            } else {
                this.employeeStatusDetailLoading = false;
            }
        },

        deleteStatusDetail() {
            this.employeeStatusDetailLoading = true;
            return http.delete("EmployeeStatusDetails/" + this.employeeStatusDetailEditForm.code).then(res => {
                this.fetchStatusDetail();
            }).finally(() => {
                this.deleteStatusDetailCfm = false;
                this.employeeStatusDetailLoading = false;
                this.employeeStatusDetailEditForm.code = "";
                this.employeeStatusDetailEditForm.status = "";
                this.employeeStatusDetailEditForm.fromDate = "";
                this.employeeStatusDetailEditForm.toDate = "";
            });
        },

        //promote details
        setPromoteDetailForm(item) {
            return http.get("employeePromoteDetails/" + item.id).then(res => {
                var item = res.data.data;
                this.employeePromoteDetailForm.id = item.id;
                this.employeePromoteDetailForm.positionCode = item.positionCode;
                this.employeePromoteDetailForm.positionStateCode = item.positionStateCode;
                this.employeePromoteDetailForm.shiftCode = item.shiftCode;
                this.employeePromoteDetailForm.note = item.note;
                this.employeePromoteDetailForm.fromDate = moment(item.promoteDateFrom).format("DD/MM/YYYY");
                this.employeePromoteDetailForm.toDate = moment(item.promoteDateTo).format("DD/MM/YYYY");

                this.promoteDetailData.positionStates = res.data.states;
                this.promoteEdit = true;
                console.log(item);
            });
            // this.positionStateCode = 
            // this.shiftCode = 
            // this.fromDate = 
            // this.toDate = 
        },
        resetEmployeePromoteDetailForm() {
            this.employeePromoteDetailForm.id = "";
            this.employeePromoteDetailForm.shiftCode = "";
            this.employeePromoteDetailForm.positionStateCode = "";
            this.employeePromoteDetailForm.positionCode = "";
            this.employeePromoteDetailForm.fromDate = "";
            this.employeePromoteDetailForm.toDate = "";
            this.employeePromoteDetailForm.note = "";
        },

        openCreatePromoteDialog() {
            // fetch data filter
            this.resetEmployeePromoteDetailForm();
            this.fetchPosition();
            this.fetchShift();
            this.promoteAdd = true;
            this.promoteEdit = false;
        },

        fetchPosition() {
            return http.get("positions/fetch").then(res => {
                this.promoteDetailData.positions = res.data;
            });
        },
        fetchPositionState() {
            if (this.employeePromoteDetailForm.positionCode) {
                return http.get("positions/fetch-position-state/" + this.employeePromoteDetailForm.positionCode).then(res => {
                    this.promoteDetailData.positionStates = res.data;
                });
            }
        },
        fetchShift() {
            return http.get("shifts?availableOnly=true").then(res => {
                this.promoteDetailData.shifts = res.data;
            });
        },

        fetchPromoteDetail() {
            return http.get("EmployeePromoteDetails", {
                params: {
                    employeeCode: this.item.code
                }
            }).then(res => {
                this.employeePromoteDetailLoading = false;
                this.promoteTableItems = res.data;
            });
        },

        fetchPromoteDetailItem(item) {
            this.promoteAdd = true;
            if (item) {

            } else {

            }
        },

        postPromoteDetail() {

            if (this.promoteEdit) {
                this.employeePromoteDetailLoading = true;
                let postDate = {
                    positionCode: "",
                    positionStateCode: "",
                    shiftCode: "",
                    fromDate: null,
                    toDate: null,
                    note: ""
                };
                postDate.fromDate = moment(this.employeePromoteDetailForm.fromDate, "DD/MM/YYYY").format("YYYY-MM-DD");
                postDate.toDate = moment(this.employeePromoteDetailForm.toDate, "DD/MM/YYYY").format("YYYY-MM-DD");
                postDate.positionCode = this.employeePromoteDetailForm.positionCode;
                postDate.positionStateCode = this.employeePromoteDetailForm.positionStateCode;
                postDate.shiftCode = this.employeePromoteDetailForm.shiftCode;
                postDate.note = this.employeePromoteDetailForm.note;

                return http.put("EmployeePromoteDetails/" + this.employeePromoteDetailForm.id, postDate).then(res => {
                    this.fetchPromoteDetail();
                    this.employeePromoteDetailLoading = false;
                    this.promoteEdit = false;
                    this.promoteAdd = false;
                    this.employeePromoteDetailForm.id = "";
                    this.employeePromoteDetailForm.shiftCode = "";
                    this.employeePromoteDetailForm.positionStateCode = "";
                    this.employeePromoteDetailForm.positionCode = "";
                    this.employeePromoteDetailForm.fromDate = "";
                    this.employeePromoteDetailForm.toDate = "";
                    this.employeePromoteDetailForm.note = "";
                }).finally(() => {
                });
            } else {
                this.employeePromoteDetailLoading = true;
                let postDate = {
                    positionCode: "",
                    positionStateCode: "",
                    shiftCode: "",
                    fromDate: null,
                    toDate: null,
                    note: ""
                };
                postDate.fromDate = moment(this.employeePromoteDetailForm.fromDate, "DD/MM/YYYY").format("YYYY-MM-DD");
                postDate.toDate = moment(this.employeePromoteDetailForm.toDate, "DD/MM/YYYY").format("YYYY-MM-DD");
                postDate.positionCode = this.employeePromoteDetailForm.positionCode;
                postDate.positionStateCode = this.employeePromoteDetailForm.positionStateCode;
                postDate.shiftCode = this.employeePromoteDetailForm.shiftCode;
                postDate.note = this.employeePromoteDetailForm.note;
                return http.post("EmployeePromoteDetails/" + this.item.code, postDate).then(res => {
                    this.fetchPromoteDetail();
                    this.promoteAdd = false;
                    this.promoteEdit = false;
                    this.employeePromoteDetailLoading = false;
                });
            }
        },

        // putPromoteDetail(item) {
        //     let putDate = {
        //         status:1,
        //         fromDate: null,
        //         toDate:null
        //     };
        //     this.employeeStatusDetailLoading = true;

        //     putDate.fromDate = moment(this.employeeStatusDetailEditForm.fromDate, "DD/MM/YYYY").format("YYYY-MM-DD");
        //     putDate.toDate = moment(this.employeeStatusDetailEditForm.toDate, "DD/MM/YYYY").format("YYYY-MM-DD");
        //     putDate.status = this.employeeStatusDetailEditForm.status;

        //     //validate
        //     let valid = true;
        //     for (var i = 0; i < this.dateValidRules.length; i++) {
        //         if(this.dateValidRules[i](this.employeeStatusDetailEditForm.toDate) != true)
        //             valid = valid && false;
        //     }
        //     for (var i = 0; i < this.dateValidRules.length; i++) {
        //         if(this.dateValidRules[i](this.employeeStatusDetailEditForm.fromDate) != true)
        //             valid = valid && false;
        //     }
        //     valid = valid && !!this.employeeStatusDetailEditForm.fromDate && !!this.employeeStatusDetailEditForm.toDate && !!this.employeeStatusDetailEditForm.status;

        //     if(valid)
        //     {
        //         return http.put("EmployeeStatusDetails/"+item.code, putDate).then(res => {
        //             this.fetchPromoteDetail();
        //             this.statusEdit = false;
        //         }).finally(() => {
        //             this.employeeStatusDetailLoading = false;
        //         });
        //     }else {
        //         this.employeeStatusDetailLoading = false;
        //     }
        // },

        putPromoteDetail(item) {
            let putDate = {
                departmentTypeCode: "",
                departmentCode: "",
                teamCode: "",
                rotationDateFrom: null,
                rotationDateTo: null
            };
            this.employeeRotationDetailLoading = true;

            putDate.rotationDateFrom = moment(this.employeeRotationDetailForm.rotationDateFrom, "DD/MM/YYYY").format("YYYY-MM-DD");
            putDate.rotationDateTo = moment(this.employeeRotationDetailForm.rotationDateTo, "DD/MM/YYYY").format("YYYY-MM-DD");
            putDate.departmentTypeCode = this.employeeRotationDetailForm.departmentTypeCode;
            putDate.departmentCode = this.employeeRotationDetailForm.departmentCode;
            putDate.teamCode = this.employeeRotationDetailForm.teamCode;
            putDate.divisionCode = this.employeeRotationDetailForm.divisionCode;
            putDate.team2ode = this.employeeRotationDetailForm.team2ode;
            putDate.unitCode = this.employeeRotationDetailForm.unitCode;

            //validate
            let valid = true;
            for (var i = 0; i < this.dateValidRules.length; i++) {
                if (this.dateValidRules[i](this.employeeStatusDetailEditForm.toDate) != true)
                    valid = valid && false;
            }

            for (var i = 0; i < this.dateValidRules.length; i++) {
                if (this.dateValidRules[i](this.employeeStatusDetailEditForm.fromDate) != true)
                    valid = valid && false;
            }
            valid = valid && !!this.employeeStatusDetailEditForm.fromDate && !!this.employeeStatusDetailEditForm.toDate && !!this.employeeStatusDetailEditForm.status;

            this.employeeRotationDetailLoading = true;

            return http.put("employeePromoteDetails/" + this.employeePromoteDetailEditForm.id, putDate).then(res => {
                this.fetchPromoteDetail();
            }).finally(() => {
                this.employeePromoteDetailLoading = false;
                this.promoteAdd = false;
            });
        },

        deletePromoteDetail() {
            this.employeeStatusDetailLoading = true;
            return http.delete("EmployeePromoteDetails/" + this.employeePromoteDetailForm.id).then(res => {
                this.fetchPromoteDetail();
            }).finally(() => {
                this.deletePromoteDetailCfm = false;
                this.employeePromoteDetailLoading = false;
                this.employeePromoteDetailForm.id = "";
            });
        },

        //section rotation
        setRotationDetailForm(item) {
            this.employeeRotationDetailEditForm.code = item.id;
            // this.employeePromoteDetailEditForm.departmentTypeCode = item.departmentTypeCode,
            // this.employeePromoteDetailEditForm.departmentCode = item.departmentCode,
            // this.employeePromoteDetailEditForm.teamCode = item.teamCode,
            // this.employeePromoteDetailEditForm.rotationDateFrom = item.rotationDateFrom,
            // this.employeePromoteDetailEditForm.rotationDateFrom = item.rotationDateTo
        },
        openCreateRotationDialog() {
            this.fetchDepartmentType_rt();
            // fetch data filter
            this.rotationAdd = true;
            this.rotationUpdate = false;
            this.employeeRotationDetailForm.id = "";
            this.employeeRotationDetailForm.departmentTypeCode = "";
            this.employeeRotationDetailForm.departmentCode = "";
            this.employeeRotationDetailForm.teamCode = "";
            this.employeeRotationDetailForm.divisionCode = "";
            this.employeeRotationDetailForm.team2Code = "";
            this.employeeRotationDetailForm.unitCode = "";
            this.employeeRotationDetailForm.rotationDateFrom = "";
            this.employeeRotationDetailForm.rotationDateTo = "";
        },
        openUpdateRotationDialog(item) {
            this.fetchDepartmentType_rt();
            this.rotationAdd = true;
            this.rotationUpdate = true;
            this.rotationLoading = true;
            // fetch data filter
            return http.get("EmployeeRotationDetails/fetch-update/" + item.id).then(res => {
                this.departments = res.data.selects.departments;
                this.departmentTypes = res.data.selects.departmentTypes;
                this.teams = res.data.selects.teams;
                this.divisions = res.data.selects.teams;
                this.teams2 = res.data.selects.teams2;
                this.units = res.data.selects.units;
                this.rotationLoading = false;
                console.log(res.data);
                this.employeeRotationDetailForm = Object.assign({}, res.data.data);
            });
        },

        fetchRotationDetail() {
            return http.get("EmployeeRotationDetails", {
                params: {
                    employeeCode: this.item.code
                }
            }).then(res => {
                this.rotationTableItems = res.data;
            });
        },

        fetchRotationDetailItem(item) {
            this.rotationAdd = true;
            if (item) {

            } else {

            }
        },

        postRotationDetail() {
            this.employeeRotationDetailLoading = true;
            let postDate = {
                departmentTypeCode: "",
                departmentCode: "",
                teamCode: "",
                rotationDateFrom: null,
                rotationDateTo: null
            };
            postDate.rotationDateFrom = moment(this.employeeRotationDetailForm.rotationDateFrom, "DD/MM/YYYY").format("YYYY-MM-DD");
            postDate.rotationDateTo = moment(this.employeeRotationDetailForm.rotationDateTo, "DD/MM/YYYY").format("YYYY-MM-DD");
            postDate.departmentTypeCode = this.employeeRotationDetailForm.departmentTypeCode;
            postDate.departmentCode = this.employeeRotationDetailForm.departmentCode;
            postDate.teamCode = this.employeeRotationDetailForm.divisionCode;
            postDate.divisionCode = this.employeeRotationDetailForm.divisionCode;
            postDate.team2Code = this.employeeRotationDetailForm.team2Code;
            postDate.unitCode = this.employeeRotationDetailForm.unitCode;

            return http.post("EmployeeRotationDetails/" + this.item.code, postDate).then(res => {
                this.fetchRotationDetail();
                this.employeeRotationDetailLoading = false;
                this.rotationAdd = false;
                console.log("sdasda");
            });
        },

        putRotationDetail(item) {

            let putDate = {
                departmentTypeCode: "",
                departmentCode: "",
                teamCode: "",
                divisionCode: "",
                team2Code: "",
                unitCode: "",
                rotationDateFrom: null,
                rotationDateTo: null
            };
            this.employeeRotationDetailLoading = true;

            putDate.rotationDateFrom = moment(this.employeeRotationDetailForm.rotationDateFrom, "DD/MM/YYYY").format("YYYY-MM-DD");
            putDate.rotationDateTo = moment(this.employeeRotationDetailForm.rotationDateTo, "DD/MM/YYYY").format("YYYY-MM-DD");
            putDate.departmentTypeCode = this.employeeRotationDetailForm.departmentTypeCode;
            putDate.departmentCode = this.employeeRotationDetailForm.departmentCode;
            putDate.teamCode = this.employeeRotationDetailForm.divisionCode;
            putDate.divisionCode = this.employeeRotationDetailForm.divisionCode;
            putDate.team2Code = this.employeeRotationDetailForm.team2Code;
            putDate.unitCode = this.employeeRotationDetailForm.unitCode;

            //validate
            let valid = true;
            for (var i = 0; i < this.dateValidRules.length; i++) {
                if (this.dateValidRules[i](this.employeeStatusDetailEditForm.toDate) != true)
                    valid = valid && false;
            }

            for (var i = 0; i < this.dateValidRules.length; i++) {
                if (this.dateValidRules[i](this.employeeStatusDetailEditForm.fromDate) != true)
                    valid = valid && false;
            }
            valid = valid && !!this.employeeStatusDetailEditForm.fromDate && !!this.employeeStatusDetailEditForm.toDate && !!this.employeeStatusDetailEditForm.status;

            this.employeeRotationDetailLoading = true;

            return http.put("EmployeeRotationDetails/" + this.employeeRotationDetailForm.id, putDate).then(res => {
                this.fetchRotationDetail();
            }).finally(() => {
                this.employeeRotationDetailLoading = false;
                this.rotationAdd = false;
            });
        },

        deleteRotationDetail() {
            this.employeeRotationDetailLoading = true;
            return http.delete("EmployeeRotationDetails/" + this.employeeRotationDetailEditForm.code).then(res => {
                this.fetchRotationDetail();
            }).finally(() => {
                this.deleteRotationDetailCfm = false;
                this.employeeRotationDetailLoading = false;
                this.employeeRotationDetailEditForm.code = "";
            });
        },
        fetchDepartmentType_rt() {
            return http.get("departmentTypes").then(res => {
                this.departmentTypes = res.data.items;
            });
        },
        fetchDepartment_rt() {
            if (this.employeeRotationDetailForm.departmentTypeCode) {
                return http.get("departmentTypes/departments/" + this.employeeRotationDetailForm.departmentTypeCode).then(res => {
                    this.departments = res.data;
                });
            }
        },
        fetchTeam_rt() {
            if (this.employeeRotationDetailForm.departmentTypeCode) {
                return http.get("departments/teams/" + this.employeeRotationDetailForm.departmentCode).then(res => {
                    this.teams = res.data;
                    this.divisions = res.data
                    console.log(this.teams, "TEAM")
                });
            }
        },
        fetchTeam2_rt() {
            if (this.employeeRotationDetailForm.departmentTypeCode) {
                return http.get("departments/teams/" + this.employeeRotationDetailForm.divisionCode).then(res => {
                    this.teams2 = res.data;
                });
            }
        },
        fetchUnit_rt() {
            if (this.employeeRotationDetailForm.departmentTypeCode) {
                return http.get("departments/teams/" + this.employeeRotationDetailForm.team2Code).then(res => {
                    this.units = res.data;
                });
            }
        },
        getSuggestStartDayHelper() {
            console.log(this.item.code);
            return http.get("EmployeeRotationDetails/suggest-start-day?employeeCode=" + this.item.code).then(res => {
                this.employeeRotationDetailForm.rotationDateFrom = res.data;
            });
        },

        removeLanguage(employeeCode, languageEmployeeId) {
            return http.delete(`Languages/employee?employeeCode=${employeeCode}&languageEmployeeId=${languageEmployeeId}`).then(() => {
                this.fetch()
            })
        },

        updateLanguageCerts() {
            return http.put(`Languages/employee`, {
                employeeCode: this.item.code,
                certs: this.form.languageCerts
            }).then(() => {
                this.fetch()
            })
        }
    },
    created() {
    }

}